<template>
  <span>
    <div class="row container-paddingb" id="grey-container">
      <div class="container">
      <div class="row"><div class="col-md-12 col-12"><div v-bind:class="['row', {'mt-3' : width > 1023}]"><p v-bind:class="['col-md-10 white inter-style description xs_margint', {'mt-5': width > 1023}, {'mb-1': width <= 768}]" >Like what you see?</p></div></div></div>
      <div class="row roboto-style">
        <h1 class="col-lg-9 col-md-8 col-12 align-self-center title white">Let's start a conversation.</h1>
         <div v-bind:class="['col-lg-3 col-md-4 col-12 align-self-center', {'text-right': width >= 768}, {'text-left' : width < 768}]">
          <router-link v-bind:class="['font-weight-bold d-inline-block button smallbtn dark-grey greenbtn', {'float-right': width >= 678}]" to="/get-in-touch">
            Get in touch
            <arrow></arrow>
          </router-link>
        </div>
      </div>
      </div>
    </div>
  </span>
</template>

<script>
    import Arrow from './arrow';
    export default {
        components: {
            Arrow: Arrow
        },
        data() {
            return {
                width: 0
            }
        },
        computed: {
            windowWidth: {
                get: function () {
                    return this.width;
                },
                set: function (val) {
                    this.width = val;
                }

            }
        },
        mounted() {
            this.width = window.innerWidth;
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/conversation.vue